import { Component, computed, inject, input, signal } from '@angular/core';
import { Router } from '@angular/router';
// import { AssetsService } from '../../services/assets.service';
import {
  I18nService,
  UiService,
  DateFormatSettings,
  Notification,
  NavButtonComponent,
  BreadcrumbsComponent,
} from '@lp-ui-lib';
import { CommonModule } from '@angular/common';
import { SensorInstructionComponent } from '../sensor-instruction/sensor-instruction';
import { NotificationAlertComponent } from '../notification-alert/notification-alert';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { DocumentationWizardComponent } from '../documentation-wizard/documentation-wizard';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.html',
  styleUrls: ['./notification.scss'],
  imports: [
    SensorInstructionComponent,
    NavButtonComponent,
    BreadcrumbsComponent,
    CommonModule,
    NotificationAlertComponent,
    NzIconModule,
    DocumentationWizardComponent,
  ],
})
export class NotificationComponent {
  private router = inject(Router);
  public ui = inject(UiService);
  // private assetsService = inject(this.assetsService);
  // revisit by Prince
  public i18n = inject(I18nService);

  // Use input() to define component inputs
  public dateFormat = input<DateFormatSettings | null>(null);
  public notification = input.required<Notification>();
  public filtered = input(false);

  // Use signals for reactive state
  public overlayDocumentation = signal(false);
  public overlayInstructions = signal(false);
  public documentationAdded = signal(false);
  isMobile = computed<boolean>(() => this.ui.IsMobile());
  isTablet = computed<boolean>(() => this.ui.IsTablet());
  isDesktop = computed<boolean>(() => this.ui.IsDesktop());
  breadcrumbs = computed<any>(() => this.notification().breadcrumbs ?? []);
  // Replace the 'DateFormat' getter with a computed signal
  public dateFormatString = computed(() => {
    return this.dateFormat()?.formatString === 'MM/dd/yyyy'
      ? 'MM/dd/yyyy | h:mm a'
      : 'dd-MM-yyyy | HH:mm';
  });

  onDocumentationAdded(evt: any): void {
    // Update the signal directly
    this.documentationAdded.set(evt);
  }

  onRepairAndReplace(): void {
    const notification = this.notification();
    if (notification) {
      this.router.navigate(['repair', notification.objectID, notification.sensorID]);
    }
  }

  onAssetName(): void {
    const notification = this.notification();
    if (notification) {
      this.router.navigate(['asset', notification.objectID, notification.sensorID]);
    }
  }
}
